<template>
  <!-- 个人中心 -->
  <crec-modal title="基本资料" class="personalDialog" :visible.sync="computedShow" width="400px" append-to-body @ok="submit" @cancel="handleClose">
    <crec-form-model ref="form" :model="passwordForm" :rules="rules" label-width="80px" >
      <crec-form-model-item label="用户名">
        {{userName}}
      </crec-form-model-item>
      <crec-form-model-item prop="oldPassword" label="旧密码">
        <crec-input-password v-model="passwordForm.oldPassword"  placeholder="请输入旧密码" show-password></crec-input-password>
      </crec-form-model-item>
      <crec-form-model-item prop="newPassword" label="新密码">
        <crec-input-password v-model="passwordForm.newPassword"  placeholder="请输入新密码" show-password></crec-input-password>
      </crec-form-model-item>
      <crec-form-model-item prop="confirmPassword" label="确认密码">
        <crec-input-password v-model="passwordForm.confirmPassword" placeholder="请输入确认密码" show-password></crec-input-password>
      </crec-form-model-item>
    </crec-form-model>
  </crec-modal>
</template>

<script>
import { RegexUtil } from "@/utils/base/RegexUtil";
import { updateWebUserPwd } from "@/api/system/user";

export default {
  name:'LoginInfo',
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      loading: false,
      passwordForm:{
        confirmPassword:'',
        oldPassword:'',
        newPassword:'',
      },
      // 重置密码表单校验
      rules: {
        oldPassword: [
          { required: true, message: "旧密码不能为空", trigger: "blur" },
        ],
        newPassword: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!RegexUtil.isValidPassword(value)) {
                callback(
                  new Error(
                    "必须包含大小写字母、数字、特殊字符， 8 到 30 个字符"
                  )
                );
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "确认密码不能为空", trigger: "blur" },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.passwordForm.newPassword !== value) {
                callback(new Error("两次输入的密码不一致"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      openType: '',
      userName: ''
    };
  },
  computed: {
    computedShow: {
      get() {
        return this.show
      }
    }
  },
  watch: {
    // 监听obj属性变化
    show: function (newVal) {
      if(newVal){
        this.userName = localStorage.getItem("loginUser");
      }
    },
  },
  created() {
    // this.userName = localStorage.getItem("loginUser");
  },
  methods: {

    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateWebUserPwd(this.passwordForm.oldPassword, this.passwordForm.newPassword).then(() => {
            this.$modal.msgSuccess("修改成功");
            this.$store.dispatch('LogOut').then(() => {
              this.handleClose();
              this.$emit('loginOut');
              this.$router.push('/');
            })
          });
        }
      });
    },

    handleClose(val){
      this.$emit('closeValue',val);
    },

  },
};
</script>
<style lang="less">
  .personalDialog{
    .el-dialog__header{
      padding: 10px 20px 8px;
      .el-dialog__headerbtn{top: 12px}
      border-bottom: 1px solid #eeeeee;
    }
    .el-dialog__body{
      height: 300px;
    }
    .crec-form-item-label {
      float: left;
      width: 70px;
      font-weight: bold;
    }
    .crec-form-item-control-wrapper {
      margin-left: 70px;
    }
    .el-tabs{
      .el-tabs__header{
        .el-tabs__nav-wrap::after{display: none}
      }
    }
  }
</style>
